import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Translations } from "../localization/translations";

interface IKlasisLoaderProps {
    hideTitle?: boolean;
}

const KlasisLoader: React.FC<IKlasisLoaderProps> = (props: IKlasisLoaderProps): JSX.Element => {
    const { t } = useTranslation();

    return (
        <Box 
            display="flex" 
            justifyContent="center" 
            alignItems="center" 
            flexDirection="column"
            margin={1}
            height="100%"
        >
            <CircularProgress size="2rem" />
            
            {props.hideTitle ?? 
                <Box marginTop={1}>
                    <Typography>
                        {t(Translations.common.label.loadingData)}
                    </Typography>
                </Box>}
        </Box>
    );
}

export default KlasisLoader;